// Conditional-visibility helpers for the TPRM questionnaire: the shared rules in
// ./questionVisibility.js bound to TPRMQuestion's id and order fields, plus TPRM's own
// category grouping. Semantics must stay in lockstep with
// backend/Services/ConditionalQuestionRules.cs.

import { groupQuestionsByCategory as groupByCategory } from './assessmentSections';
import { createQuestionVisibility } from './questionVisibility';

const v = createQuestionVisibility({ idField: 'tprmQuestionId', orderField: 'tprmQuestionOrder' });

export const {
    buildQuestionMap,
    isQuestionVisible,
    orderQuestionsWithChildren,
    inheritRootCategory,
    getVisibleQuestions,
    collectDescendantAnswersToClear,
    collectDescendantIds,
} = v;

// Regroups questions so each category's questions are contiguous (the question bank
// interleaves categories). Categories keep first-appearance order; questions keep their
// incoming order within a category. Run BEFORE orderQuestionsWithChildren so navigation
// walks one section at a time.
export function groupQuestionsByCategory(questions) {
    return groupByCategory(questions, 'tprmQuestionCategory');
}
